import React, { useEffect } from "react"
import { BrowserRouter, Route, Routes, Outlet } from "react-router-dom"
import intl from "react-intl-universal"

import "./App.scss"
import SideBar from "./components/molecules/sidebar/Index"
import Dashboard from "./pages/Dashboad"
import Quadros from "./pages/Quadros"
import Blocks from "./pages/Blocks"
import CIQ from "./pages/CIQ"
import Plan from "./pages/Plan"
import Extract from "./pages/Extract"
import ImportDocuments from "./components/templates/DocumentPage/pages/ImportDocuments"
import SIGMA from "./pages/SIGMA"
import ListAnalitesInEquipment from "./components/templates/SIGMAPage/pages/ListAnalitesInEquipment"
import ListAnalytes from "./components/templates/CQIPage/pages/ListAnalytes"
import { PaineisContextProvider } from "./contexts/Paineis"
import { AuthContextProvider } from "./contexts/Auth"
import { StatesOfModalsProvider } from "./contexts/StatesOfModals"
import { FieldsContextProvider } from "./contexts/Fields"
import { BoardContextProvider } from "./contexts/Board"
import { ErrorContextProvider } from "./contexts/Error"
import { BlocksContextProvider } from "./contexts/Blocks"
import ActivityForm from "./components/templates/ActivityForm"
import { FormContextProvider } from "./contexts/Form"
import { SideBarContextProvider } from "./contexts/SideBar"
import { AutomationContextProvider } from "./contexts/Automation"
import { fnDecodeStorageToken } from "./utils/encodeLocalStorage"
import ListEquipaments from "./components/templates/CQIPage/pages/ListEquipament"
import AddControls from "./components/templates/CQIPage/pages/AddControls"
import AddEquipaments from "./components/templates/CQIPage/pages/AddEquipaments"
import EditEquipament from "./components/templates/CQIPage/pages/EditEquipaments"
import DuplicatedEquipaments from "./components/templates/CQIPage/pages/DuplicatedEquipment"
import DuplicatedControl from "./components/templates/CQIPage/pages/DuplicatedControl"
import EditControl from "./components/templates/CQIPage/pages/EditControl"
import ListControlls from "./components/templates/CQIPage/pages/ListControls"
import Releases from "./components/templates/CQIPage/pages/Releases"
import EquipmentMinimal from "./components/templates/CQIPage/pages/EquipmentMininal"
import { WestgardRulesProvider } from "./contexts/Equipments"
import { ControlsProviders } from "./contexts/Controls"
import Reports from "./components/templates/CQIPage/pages/Reports"
import AutomationActivity from "./pages/AutomationActivity"
import ReleaseDetails from "./components/templates/CQIPage/pages/ReleaseDetails"

import FilterProvider, { FilterContext } from "./contexts/Filter"

const oLanguages = {
  "pt-br": "pt-br",
  pt_br: "pt-br",
  pt: "pt-br",
  br: "pt-br",
  en_us: "en",
  "en-us": "en",
  us: "en",
  en: "en",
}

function PublicLayout() {
  return (
    <div>
      <ActivityForm />
    </div>
  )
}

function AppLayout() {
  return (
    <div>
      <AuthContextProvider>
        <SideBarContextProvider>
          <SideBar>
            <PaineisContextProvider>
              <ControlsProviders>
                <WestgardRulesProvider>
                  <PaineisContextProvider>
                    <BoardContextProvider>
                      <BlocksContextProvider>
                        <FilterProvider>
                          <StatesOfModalsProvider>
                            <FieldsContextProvider>
                              <FormContextProvider>
                                <AutomationContextProvider>
                                  <ErrorContextProvider>
                                    <Outlet />
                                  </ErrorContextProvider>
                                </AutomationContextProvider>
                              </FormContextProvider>
                            </FieldsContextProvider>
                          </StatesOfModalsProvider>
                        </FilterProvider>
                      </BlocksContextProvider>
                    </BoardContextProvider>
                  </PaineisContextProvider>
                </WestgardRulesProvider>
              </ControlsProviders>
            </PaineisContextProvider>
          </SideBar>
        </SideBarContextProvider>
      </AuthContextProvider>
    </div>
  )
}

function App() {
  const oLocales = {
    en: require("./locales/en.json"),
    "pt-br": require("./locales/pt-br.json"),
  }

  useEffect(() => {
    const cLanguage =
      fnDecodeStorageToken()?.cLanguage ||
      intl.determineLocale()?.toLocaleLowerCase() ||
      "pr-br"
    intl.init({
      currentLocale: oLanguages[cLanguage],
      locales: oLocales,
    })
  }, [])

  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <Routes>
        <Route path="/" element={<AppLayout />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/plan" element={<Plan />} />
          <Route path="/extract" element={<Extract />} />
          <Route path=":panelId/boards" element={<Quadros />} />
          <Route path=":panelId/boards/:boardId/new-board" element={<Blocks newBoard={true} />} />
          <Route path=":panelId/boards/:boardId/:blockId" element={<Blocks />} />
          <Route path=":panelId/boards/:boardId" element={<Blocks />} />
          <Route path="/folder/:folderId/files" element={<ImportDocuments />} />
          <Route path="/ciq" element={<CIQ />} />
          <Route path="/ciq/equipment" element={<EquipmentMinimal />} />

          <Route path="ciq/list-analytes" element={<ListAnalytes />} />
          <Route path="ciq/list-equipments" element={<ListEquipaments />} />
          <Route path="ciq/list-controls" element={<ListControlls />} />
          <Route path="ciq/edit-control/:id" element={<EditControl />} />
          <Route path="ciq/duplicated-control/:id" element={<DuplicatedControl />} />

          <Route path="ciq/create-control" element={<AddControls />} />
          <Route path="ciq/create-equipment" element={<AddEquipaments />} />
          <Route path="ciq/edit-equipment/:id" element={<EditEquipament />} />

          <Route path="ciq/release/:id" element={<Releases />} />
          <Route
            path="ciq/release/:equipmentId/details/:analyteId"
            element={<ReleaseDetails />}
          />
          <Route
            path="ciq/duplicated-equipment/:id"
            element={<DuplicatedEquipaments />}
          />

          <Route path="ciq/generate-report" element={<Reports />} />
          {/* SIGMA */}
          <Route path="ciq/sigma" element={<SIGMA />} />
          <Route
            path="ciq/sigma/list-analytes-in-equipment/:id"
            element={<ListAnalitesInEquipment />}
          />

          <Route
            path=":panelId/boards/:boardId/:blockId/:activityId?"
            element={<Blocks />}
          />
          <Route path=":automation/:aut_id/:cust_nid" element={<AutomationActivity />} />
        </Route>
        <Route path="/" element={<PublicLayout />}>
          <Route path="/activityForm/:idForm/:id" element={<ActivityForm />} />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export default App
